module.exports = __webpack_public_path__ + "img/3.e148d4cb.svg";